<script>
	import { menu, menuSub, menuSubSub, checkedList, check } from "../stores";
	import { onMount } from "svelte";

	// 현재 선택된 서버 확인
	let selectedServer = "";
	let isChinaServer = false;

	onMount(() => {
		selectedServer = localStorage.getItem("selectedServer") || "";
	});

	// 서버 변경 감지를 위한 반응형 변수
	$: selectedServer = localStorage.getItem("selectedServer") || "";

	// 중국 서버 여부 확인
	$: {
		isChinaServer = selectedServer === "dev-api-backstage.blaupunkt-solum.cn" || selectedServer === "api-backstage.blaupunkt-solum.cn";
		console.log(isChinaServer);
		console.log(selectedServer);
	}

	// 메뉴 데이터 구조 - 반응형으로 변경
	$: listMenu = [
		{
			title: "컨텐츠 관리",
			menus: [
				{
					title: "장르 관리",
					icon: "category",
					src: "",
					subs: [{ title: "컨텐츠 장르", src: "/contents/category/contents" }],
				},
				{
					title: "음원 관리",
					icon: "music",
					src: "",
					subs: [
						{ title: "소스 음원", src: "/contents/sound/sources" },
						{ title: "컨텐츠 음원", src: "/contents/sound/musics" },
						{ title: "명상 사운드 신호", src: "/contents/sound/signals" },
						/// 중국서버가 아닐 경우만 표시
						// ...(isChinaServer
						// 	? []
						// 	: [
						// 			{ title: "수면 음원 (기존)", src: "/contents/musics/sleeps" },
						// 			{ title: "명상 음원 (기존)", src: "/contents/musics/meditations" },
						// 			{ title: "포커스 음원 (기존)", src: "/contents/musics/focus" },
						// 		]),
					],
				},
				{
					title: "공지사항 관리",
					icon: "bell",
					src: "/contents/notices",
					subs: [],
				},
				{
					title: "AI 리포트 관리",
					icon: "brain",
					src: "",
					subs: [{ title: "AI 리포트 프롬프트", src: "/contents/ai-report-prompt" }],
				},
			],
		},
		{
			title: "버전 관리",
			menus: [
				{
					title: "앱 버전",
					icon: "mobile",
					src: "/version/app",
					subs: [],
				},
				{
					title: "알고리즘 버전",
					icon: "brain",
					src: "/version/algorithm",
					subs: [],
				},
				{
					title: "펌웨어 버전",
					icon: "microchip",
					src: "/version/firmware",
					subs: [],
				},
			],
		},
		// 중국 서버가 아닐 때만 디바이스 관리 메뉴 표시
		...(isChinaServer
			? []
			: [
					{
						title: "디바이스 관리",
						menus: [
							{
								title: "유통채널 관리",
								icon: "store",
								src: "/device/distribution",
								subs: [],
							},
							{
								title: "디바이스 관리",
								icon: "devices",
								src: "/device/management",
								subs: [],
							},
						],
					},
				]),
		{
			title: "사용자 관리",
			menus: [
				{
					title: "관리자 관리",
					icon: "user",
					src: "/admin/management",
					subs: [],
				},
				{
					title: "사용자 조회",
					icon: "user",
					src: "/user/management",
					subs: [],
				},
				{
					title: "사용자 활동",
					icon: "activity",
					src: "/user/activity",
					subs: [
						{ title: "활동로그", src: "/user/activity/log" },
						{ title: "수면활동", src: "/user/activity/sleep" },
					],
				},
			],
		},
		{
			title: "삼성 헬스 비교",
			menus: [
				{
					title: "수면 세션 목록",
					icon: "list-ul",
					src: "/samsung/sessions",
					subs: [],
				},
				{
					title: "통계 대시보드",
					icon: "bar-chart-alt-2",
					src: "/samsung/statistics",
					subs: [],
				},
			],
		},
		{
			title: "로그 관리",
			menus: [
				{
					title: "API 호출 로그",
					icon: "bar-chart",
					src: "/log/api",
					subs: [],
				},
				{
					title: "앱 로그",
					icon: "line-chart",
					src: "/log/app",
					subs: [],
				},
			],
		},
		{
			title: "이메일 관리",
			menus: [
				{
					title: "발송 테스트",
					icon: "mail-send",
					src: "/email/test",
					subs: [],
				},
			],
		},
	];

	// 현재 선택된 메뉴 상태
	let current = "Home";
	let currentSub = "Dashboard";
	let currentSubSub = "";

	// 메뉴 상태 업데이트 함수
	function updateMenuState(menuTitle, subTitle, subSubTitle = "") {
		current = menuTitle;
		currentSub = subTitle;
		currentSubSub = subSubTitle;
	}

	// 체크박스 초기화 함수
	function resetCheckboxes() {
		checkedList.set([]);
		check.set(false);
	}

	// 메뉴 아이템 클릭 핸들러
	function handleMenuItemClick(menuTitle, subTitle, subSrc, hasSubs) {
		if (!hasSubs) {
			updateMenuState(menuTitle, subTitle);
		}
	}

	// 서브메뉴 아이템 클릭 핸들러
	function handleSubMenuItemClick(menuTitle, subTitle, subSubTitle) {
		updateMenuState(menuTitle, subTitle, subSubTitle);
	}
</script>

<nav id="layout-menu" class="menu-vertical menu bg-menu-theme" style="display:flex;">
	<div class="app-brand demo">
		<a
			href="/monitor/mqtt"
			class="d-flex justify-content-center"
			style="cursor: pointer;"
			on:click|preventDefault={() => {
				updateMenuState("모니터링", "MQTT 모니터링");
				handleMenuItemClick("모니터링", "MQTT 모니터링", "/monitor/mqtt", false);
			}}
		>
			<img alt="로고" src="/assets/img/logo.png" width="150" />
		</a>
	</div>

	<div class="menu-inner-shadow" />

	<div class="d-flex flex-column" style="height: calc(100vh - 80px);">
		<ul class="menu-inner py-1 flex-grow-1">
			<li class="menu-item {currentSub === 'MQTT 모니터링' ? 'active open' : ''}">
				<a
					href="javascript:void(0)"
					class="menu-link menu-toggle"
					on:click|preventDefault={() => {
						updateMenuState("모니터링", "MQTT 모니터링");
					}}
				>
					<i class="menu-icon tf-icons bx bx-desktop" />
					<div data-i18n="Analytics">MQTT 모니터링</div>
				</a>
				<ul class="menu-sub">
					<li class="menu-item {currentSubSub === '실시간 모니터링' ? 'active' : ''}">
						<a href="/monitor/mqtt" class="menu-link"
							on:click|preventDefault={() => handleSubMenuItemClick("모니터링", "MQTT 모니터링", "실시간 모니터링")}>
							<div data-i18n="Basic Inputs">실시간 모니터링</div>
						</a>
					</li>
					<li class="menu-item {currentSubSub === 'MQTT 로그' ? 'active' : ''}">
						<a href="/monitor/mqtt-logs" class="menu-link"
							on:click|preventDefault={() => handleSubMenuItemClick("모니터링", "MQTT 모니터링", "MQTT 로그")}>
							<div data-i18n="Basic Inputs">MQTT 로그</div>
						</a>
					</li>
				</ul>
			</li>

			{#each listMenu as menuGroup}
				<li class="menu-header text-uppercase">
					<span class="menu-header-text">{menuGroup.title}</span>
				</li>

				{#each menuGroup.menus as item}
					{@const hasSubs = item.subs.length > 0}
					{@const isActive = currentSub === item.title}

					<li class="menu-item {isActive ? 'active' : ''} {isActive && hasSubs ? 'open' : ''}">
						<a
							href={item.src || "javascript:void(0)"}
							class="menu-link {hasSubs ? 'menu-toggle' : ''}"
							on:click|preventDefault={() => {
								if (hasSubs) {
									updateMenuState(menuGroup.title, item.title);
								} else {
									handleMenuItemClick(menuGroup.title, item.title, item.src, hasSubs);
								}
							}}
						>
							<i class="menu-icon tf-icons bx bx-{item.icon}" />
							<div data-i18n="Form Elements">
								{item.title}
							</div>
						</a>

						{#if hasSubs}
							<ul class="menu-sub">
								{#each item.subs as sub}
									{@const isSubActive = currentSubSub === sub.title}

									<li class="menu-item {isSubActive ? 'active' : ''}">
										<a
											href={sub.src}
											class="menu-link"
											on:click|preventDefault={() => handleSubMenuItemClick(menuGroup.title, item.title, sub.title)}
										>
											<div data-i18n="Basic Inputs">
												{sub.title}
											</div>
										</a>
									</li>
								{/each}
							</ul>
						{/if}
					</li>
				{/each}
			{/each}
		</ul>
	</div>
</nav>
